const employerPOCQuery = (id) => {
    return `
    query {
      deletePOC(id: "${id}")
    }
    `
}

export default employerPOCQuery